import React from 'react'
import {
  IconLockNew20,
  Tooltip,
} from '@lightspeed/unified-components-helios-theme/react'
import { useUcPortalTarget } from '../../../shared/useUcPortalTarget'
import {
  LineItemLockedIconProps,
  useLineItemLockedIconModel,
} from './useLineItemLockedIconModel'

export const LineItemLockedIcon = (props: LineItemLockedIconProps) => {
  const { tooltipInfo } = useLineItemLockedIconModel(props)
  const { portalTargetRef } = useUcPortalTarget()

  if (!tooltipInfo) {
    return null
  }

  return (
    <div className="uc-base">
      {/* .li-cell-summary-container has align children by baseline 
      but because children have different height(this icon is bigger than text) 
      we have to tweak its position */}
      <div className="pr-3 relative top-1">
        <Tooltip
          placement="bottom-end"
          portalTargetRef={portalTargetRef}
          closeDelay={200}
          customClasses={{
            content: ['max-w-80'],
          }}
          controlSlot={<IconLockNew20 data-testid="line-item-locked-icon" />}
        >
          <strong>{tooltipInfo.title}</strong>
          <div>{tooltipInfo.message}</div>
        </Tooltip>
      </div>
    </div>
  )
}
